export default __webpack_public_path__ + "static/media/cag.2d5c0ebf.jpg";